import React from 'react';
import styled from 'styled-components';
import {AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import _ from 'lodash'

const Container = styled.div`
    padding-left: ${props => `${props.depth * 1.5}rem`};
    display: ${props => !props.disableVirtual && 'grid'};
    grid-template-rows: ${props => !props.disableVirtual && 'auto 1fr auto'};
    position: relative;
    min-width: ${props => props.styles.minWidth};
    padding: ${props => !props.depth && props.styles.padding};
    margin: ${props => props.styles.margin};
    width: 100%;
    /* display: block; */
    touch-action: manipulation;
    /* opacity: ${props => props.styles.opacity};
    border: ${props => props.styles.border};
    padding: ${props => props.styles.padding};
    border-radius: 5px;
    max-height: ${props => props.styles.maxHeight};
    overflow: ${props => props.styles.overflow};
    width: ${props => props.styles.treeWidth};
    height: ${props => props.styles.treeHeight}; */
    /* border: ${props => props.isDragging && '1px solid var(--focus-color)'}; */
`

const CollapseIndicator = styled.div`
    position: absolute;
    z-index: 2300;
    top: -0.5rem;
    right: -0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    background-color: var(--focus-color);
    font-size: 0.8rem;
    font-weight: bolder;
    color: #fff;
`


const defaultStyle = {
    border: '1px solid transparent',
	borderRadius: '5px'
}

// const animateLayoutChanges = ({isSorting, wasDragging}) => isSorting || wasDragging ? false : true;
const animateLayoutChanges = (args) => defaultAnimateLayoutChanges({...args, wasDragging: true})

const SortableTreeItem = ({id, depth, containerId, disableDrag, dragHandle = 0, styles, collapseCount, disableVirtual, ...props}) => {
    const {
        attributes,
        isDragging,
        isSorting,
        listeners,
        setNodeRef,
        setDraggableNodeRef, 
        setDroppableNodeRef,
        transform,
        transition,
    } = useSortable({ id, animateLayoutChanges, data: { type: props.type }, disabled: disableDrag });
    const updatedStyle = Object.assign({}, defaultStyle, _.pick(styles, ['minWidth', 'padding', 'margin']))
    // const children = React.useMemo(() => {
    //     console.log('[SortableTreeItem]', {isDragging, depth})
    //     if(props.children.length > 1) {
    //         return props.children.map(child => (child && React.cloneElement(child, {isDragging})))
    //     } else {
    //         return props.children ? React.cloneElement(props.children, {isDragging}) : props.children
    //     }
    // }, [isDragging, depth])

    // React.useEffect(() => {
    //     console.log('[Unmounted]', id)
    // }, [props.id])

    const style = {
        ..._.omit(styles, ['minWidth', 'padding', 'margin']),
        transform: CSS.Translate.toString(transform),
        transition,
    }
    
    // return children
    if (props.children.length > 1) {
        const children = props.children.map(child => (child && React.cloneElement(child, {isDragging})))
        return (
            <Container key={id} styles={updatedStyle}
                depth={depth} disableVirtual={disableVirtual} isDragging={isDragging}
                ref={setDroppableNodeRef}  style={style} {...attributes} {...listeners} >
                {children.map((child,index) => (
                    index === dragHandle ? <div key={id} ref={setDraggableNodeRef}  {...attributes} {...listeners} >{child}</div> : <div key={`${id}_${index}`}>{child}</div>
                ))}
                {collapseCount && <CollapseIndicator>{collapseCount}</CollapseIndicator>}
            </Container>
        )
    } else {
        const children = props.children ? React.cloneElement(props.children, {isDragging}) : props.children
        return (
            <Container key={id} styles={updatedStyle}
                depth={depth} disableVirtual={disableVirtual} isDragging={isDragging}
                ref={setNodeRef} style={style} {...attributes} {...listeners}>
                {children}
                {collapseCount && <CollapseIndicator>{collapseCount}</CollapseIndicator>}
                {/* {collapseCount} */}
            </Container>
        )
    }

    // if(disableDrag){
    //     return (
    //         <Container key={id} styles={updatedStyle}
    //             depth={depth} disableVirtual={disableVirtual} style={style}>
    //             {children}
    //             {collapseCount && <CollapseIndicator>{collapseCount}</CollapseIndicator>}
    //         </Container>
    //     )
    // } else if (props.children.length > 1) {
    //     // const children = props.children.map(child => (child && React.cloneElement(child, {isDragging})))
    //     return (
    //         <Container key={id} styles={updatedStyle}
    //             depth={depth} disableVirtual={disableVirtual} isDragging={isDragging}
    //             ref={setDroppableNodeRef}  style={style} {...attributes} {...listeners} >
    //             {children.map((child,index) => (
    //                 index === dragHandle ? <div key={id} ref={setDraggableNodeRef}  {...attributes} {...listeners} >{child}</div> : <div key={`${id}_${index}`}>{child}</div>
    //             ))}
    //             {collapseCount && <CollapseIndicator>{collapseCount}</CollapseIndicator>}
    //         </Container>
    //     )
    // } else {
    //     // const children = props.children ? React.cloneElement(props.children, {isDragging}) : props.children
    //     return (
    //         <Container key={id} styles={updatedStyle}
    //             depth={depth} disableVirtual={disableVirtual} isDragging={isDragging}
    //             ref={setNodeRef} style={style} {...attributes} {...listeners}>
    //             {children}
    //             {collapseCount && <CollapseIndicator>{collapseCount}</CollapseIndicator>}
    //             {/* {collapseCount} */}
    //         </Container>
    //     )
    // }

}

export default SortableTreeItem;
